import React from "react";
import * as Props from "@/types/PropTypes";
import styles from "./DailySudoku.module.scss";
import useMediaQuery from "@/utils/useMediaQuery";
import { DESKTOP_MEDIA_QUERY } from "@/constants/breakpoints";

export const ContentWrapper: React.FC<Props.Base> = ({ children }) => (
  <div className={styles.contentWrapper}>{children}</div>
);

export const AdsMobileBannerWrapper: React.FC<Props.Base> = ({ children }) => {
  const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY);
  return !isDesktop && <div className={styles.adsMobileWrapper}>{children}</div>;
};
